import { render, staticRenderFns } from "./SignupMethodChoice.vue?vue&type=template&id=1d0166ac&scoped=true&"
import script from "./SignupMethodChoice.vue?vue&type=script&lang=ts&"
export * from "./SignupMethodChoice.vue?vue&type=script&lang=ts&"
import style0 from "./SignupMethodChoice.vue?vue&type=style&index=0&id=1d0166ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0166ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle})
